import { IState } from 'shared/store';

import { selectNewbuildingKpnChatEnabled } from '../abExperiments';
import { selectIsChatsEnabled } from '../offerChat';
import { isNewbuildingFromDeveloperSelector } from '../offerData';

const selectBuilderChatOnboardingAvailable = (state: IState) => {
  const { isChatOnboardingEnabled } = state.featureToggle;
  const isChatsEnabled = selectIsChatsEnabled(state);
  const isNewbuildingFromDeveloper = isNewbuildingFromDeveloperSelector(state);

  return isChatOnboardingEnabled && isChatsEnabled && isNewbuildingFromDeveloper;
};

const selectConsultantChatOnboardingAvailable = (state: IState) => {
  return selectNewbuildingKpnChatEnabled(state);
};

/**
 * Доступен ли онбординг для кнопки чата.
 * Если в кнопку чата добавляется возможность открыть новый вид чата с онбордингом,
 * то сюда нужно добавить условие.
 */
export const selectChatOnboardingAvailable = (state: IState) => {
  return selectBuilderChatOnboardingAvailable(state) || selectConsultantChatOnboardingAvailable(state);
};
